<template>
  <div class="service_btn">
    <slot>
      <i class="iconfont icon-wodekefu btn_server_icon" @click="toService"></i>
    </slot>
    <div class="service_text" v-if="textShow">{{ $t('service_text') }}</div>
  </div>
</template>

<script>
export default {
  props: {
    textShow: Boolean
  },
  methods: {
    toService() {
      this.$store.dispatch("toService");
    },
  },
};
</script>

<style lang="less" scoped>
.service_btn {
  .iconfont {
    color: var(--gold);
    font-size: calc(34rem / 16);
  }

  .service_text {
    color: var(--light);
    // margin-top: 40px;
    width: calc(100rem / 16);
    text-align: right;
    font-size: calc(12rem / 16);
  }
}
</style>